"use strict";
var hlp = require('common/helpers');
module.exports = function(entities, schema, relationSchema) {
  var env = this;
  this.entities = entities;
  this.schema = schema;
  this.runAddEntity = function(entity, childType, relationType, fields) {
    if (entity == null) {
      entity = this.getActiveEntity();
    }
    if (!entity) {
      entity = entities[0];
    }
    if (typeof entity == 'undefined' || entity == null) {
      throw "Fehler, Entität nicht gesetzt oder gefunden!";
    }
    if (typeof childType == 'undefined' || childType == null) {
      throw "Fehler, Typ nicht gesetzt oder gefunden!";
    }
    var finalRelationType = null;
    var currentEntity = entity;
    while (currentEntity && !finalRelationType) {
      var finalRelationType = this.checkRelationTyp(currentEntity, childType, relationType);
      if (!finalRelationType)
        currentEntity = currentEntity.parent;
    }
    if (!finalRelationType && relationSchema.root.indexOf(childType) != -1) {
      var newEntity = this.addChildEntity(null, childType, null);
      this.setEntity(newEntity, fields, this.addToConsole);
      return;
    }
    if (!finalRelationType) {
      if (relationType) {
        throw "Fehler: keine Relation '" + relationType + "' von Entität " + entity.id + "/" + entity.typ + " zu einer Entität '" + childType + "' gefunden";
      } else {
        throw "Fehler: mögliche Relation von Entität " + entity.id + "/" + entity.typ + " zu einer Entität '" + childType + "' gefunden";
      }
    }
    var newEntity = this.addChildEntity(currentEntity, childType, finalRelationType);
    this.setEntity(newEntity, fields, this.addToConsole);
  };
  this.checkRelationTyp = function(entity, type, relationType) {
    var relationSchema = this.getRelations();
    var rel = relationSchema[entity.typ];
    if (!hlp.isSet(rel) || rel.length < 1) {
      return null;
    }
    for (var i = 0; i < rel.length; ++i) {
      if (rel[i].target.indexOf(type) != -1 && rel[i].hierarchy == "child" && (!relationType || rel[i].typ == relationType)) {
        return rel[i].typ;
      }
    }
    return null;
  };
  this.runUpdateEntity = function(entity, fields) {
    if (entity == null) {
      entity = this.getActiveEntity();
    }
    if (typeof entity == 'undefined' || entity == null) {
      throw "Fehler, Entität nicht gesetzt oder gefunden!";
    }
    return this.setEntity(entity, fields, this.addToConsole);
  };
  this.getEntityById = function(id) {
    for (var i = 0; i < entities.length; ++i) {
      if (entities[i].id.toUpperCase() == id.toUpperCase())
        return entities[i];
    }
    return null;
  };
  var getAllowedRelations = function(sourceId, destId, hierarchy) {
    var sourceEntity = env.getEntityById(sourceId);
    var destEntity = env.getEntityById(destId);
    var allowedRelations = [];
    var relSchema = relationSchema[sourceEntity.typ];
    if (relSchema) {
      for (var i = 0; i < relSchema.length; ++i) {
        if (relSchema[i].target.indexOf(destEntity.typ) != -1 && relSchema[i].hierarchy == hierarchy)
          allowedRelations.push(relSchema[i].typ);
      }
    }
    return allowedRelations;
  };
  this.runLinkEntities = function(source, dest, typ, hierarchy) {
    source = source.toUpperCase();
    dest = dest.toUpperCase();
    var sourceEntity = this.getEntityById(source);
    var destEntity = this.getEntityById(dest);
    var allowedRelations = getAllowedRelations(source, dest, hierarchy);
    if (!typ && allowedRelations.length > 0) {
      typ = allowedRelations[0];
    }
    if (allowedRelations.indexOf(typ) == -1) {
      var allowedRelationsInv = getAllowedRelations(dest, source, hierarchy);
      if (!typ && allowedRelationsInv.length > 0) {
        typ = allowedRelationsInv[0];
      }
      if (allowedRelationsInv.indexOf(typ) != -1) {
        this.createRelation(dest, source, typ);
      } else {
        var reason = "Verbindung '" + typ + "' zwischen Entitäten '" + sourceEntity.typ + "' und '" + destEntity.typ + "' nicht erlaubt!";
        if (allowedRelations.length > 0)
          reason = reason + " Erlaubte Relationen sind " + allowedRelations.join(', ');
        else
          reason = reason + " Zwischen diesen Entitäten sind keine Relationen definiert.";
        throw reason;
      }
    } else {
      this.createRelation(source, dest, typ);
      this.selectEntityFromCommandLine(source);
    }
  };
  return this;
};
